import { LoaderFunction } from "react-router-dom";
import { medicationsApi } from "src/api/services/medicationsApi";
import { store } from "src/api/store";

export const medicationsLoader: LoaderFunction = ({ params }) => {
  if (params.productId != null) {
    return store
      .dispatch(
        medicationsApi.endpoints.getMedicationsPerProduct.initiate({
          product_id: Number(params.productId),
        }),
      )
      .unwrap();
  }
};
